import { render, staticRenderFns } from "./LinkTenantSettingTable.vue?vue&type=template&id=5287fa4e&scoped=true"
import script from "./LinkTenantSettingTable.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingTable.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingTable.vue?vue&type=style&index=0&id=5287fa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287fa4e",
  null
  
)

export default component.exports